import { action, observable, computed, runInAction } from 'mobx';

class LoaderStore {
    @observable accessor _loading = observable.box(false);
    @observable accessor pastDelay = observable.box(false);

    @computed
    get loading() {
        return this._loading.get() && (this.pastDelay.get() || this.initial);
    }

    options = null;
    delayTimeout = null;
    initial = true;

    constructor(options) {
        // suspend/resume/setPastDelay used to be arrow-function class fields; makeObservable
        // can only annotate prototype methods, so under MobX 6 strict-mode the previous
        // shape silently lost the @action wrap and every observable.box.set() leaked a warn.

        this.options = Object.assign({
            delay: 100
        }, options);
    }

    destroy() {
        this.clearDelay();
    }

    @action.bound
    suspend(customDelay = undefined) {
        this._loading.set(true);
        this.pastDelay.set(false);

        const delay = customDelay !== undefined ? customDelay : this.options.delay;
        if (delay === 0) {
            this.pastDelay.set(true);
        } else {
            this.delayTimeout = setTimeout(() => {
                // setTimeout callback runs outside the suspend action; rewrap.
                runInAction(() => this.pastDelay.set(true));
            }, delay);
        }
    }

    @action.bound
    resume() {
        this.initial = false;
        this._loading.set(false);
        this.pastDelay.set(true);
    }

    clearDelay() {
        clearTimeout(this.delayTimeout);
        this.delayTimeout = undefined;
    }

    @action.bound
    setPastDelay() {
        this.pastDelay.set(true);
    }
}

export default LoaderStore;